import fp from 'lodash/fp';

// Currently 1 user can only be associated with 1 business.
export const externalCpdForEditSelector = fp.get('externalCpd.externalCpd')
export const isFetchingExternalCpdForEditSelector = fp.get('externalCpd.request.get.isFetching');


// WEBPACK FOOTER //
// ./src/state/modules/external-cpd/selectors.js